"use client"

import {globalConfigKeys} from "@/hooks/queries/queryKeys";
import {useBoundStore} from "@/hooks/queries/stores/use-bound-store";
import {useQuery} from "@tanstack/react-query";

export function useGlobalConfig() {
  const {fetchGlobalConfig} = useBoundStore()
  const queryKey = globalConfigKeys.config
  const queryFn = async () => {
    await fetchGlobalConfig()
    return true
  }
  const {data, isPending: loading, error} = useQuery({queryKey, queryFn})
  const config = useBoundStore(s => s.globalConfig)
  return {config: data ? config : undefined, loading, error}
}

export function usePublicConfig() {
  const {fetchPublicConfig} = useBoundStore()
  const queryKey = globalConfigKeys.publicConfig
  const queryFn = async () => {
    await fetchPublicConfig()
    return true
  }
  const {data, isPending: loading, error} = useQuery({queryKey, queryFn})
  const config = useBoundStore(s => s.publicConfig)
  return {config: data ? config : undefined, loading, error}
}
